import { connect } from 'react-redux';
import { VillageListItem, IVillageListItemDispatchProps } from '../../components/village_list_item';
import { TTypedThunkDispatch } from '../../types/store';
import { trackingPhoneEvent, trackingBuilderLinkCLick } from '../../store/tracking/tracking';
import { IVillageForListPresenterSchema } from '../../repositories/countryside-search/entities/village/VillageForListPresenterSchema';

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IVillageListItemDispatchProps {
  return {
    trackPhoneOpened(village: IVillageForListPresenterSchema) {
      dispatch(trackingPhoneEvent(village));
    },
    trackBuilderLinkCLick(village: IVillageForListPresenterSchema) {
      dispatch(trackingBuilderLinkCLick(village));
    },
  };
}

export const VillageListItemContainer = connect<void, IVillageListItemDispatchProps>(
  null,
  mapDispatchToProps,
)(VillageListItem);
